<template>
  <div class="error-page-wrapper d-flex align-items-center justify-content-center">
    
    <!-- خلفية زخرفية خفيفة -->
    <div class="bg-pattern"></div>

    <div class="text-center content-box" data-aos="fade-up">
      
      <!-- 1. الأيقونة والرقم -->
      <div class="error-icon mb-3">
        <i class="fas fa-file-circle-question fa-5x text-gold mb-3 floating-icon"></i>
        <h1 class="display-1 fw-bold text-white title-shadow">404</h1>
      </div>

      <!-- 2. الرسالة النصية -->
      <h2 class="text-white fw-bold mb-3">عذراً، الصفحة غير موجودة</h2>
      <p class="text-white-50 fs-5 mb-5 px-3">
        يبدو أنك حاولت الوصول إلى رابط غير صحيح أو أن الصفحة قد تم نقلها.<br>
        يرجى التأكد من الرابط أو العودة إلى لوحة التحكم.
      </p>

      <!-- 3. أزرار التحكم -->
      <div class="d-flex justify-content-center gap-3">
        <!-- زر العودة للخلف (History) -->
        <button @click="goBack" class="btn btn-outline-light btn-lg px-4 rounded-pill">
          <i class="fas fa-arrow-right me-2"></i> رجوع للسابق
        </button>

        <!-- زر الرئيسية -->
        <router-link to="/" class="btn btn-gold btn-lg px-4 rounded-pill fw-bold">
          <i class="fas fa-home me-2"></i> الصفحة الرئيسية
        </router-link>
      </div>

      <!-- تذييل بسيط -->
      <div class="mt-5 pt-3 border-top border-white-50">
        <p class="small text-white-50 mb-0">لجنة النظام والمراقبة - الشهادة الإعدادية</p>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "NotFound",
  methods: {
    goBack() {
      // العودة للصفحة السابقة في المتصفح
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else {
        this.$router.push('/');
      }
    }
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Cairo:wght@400;600;700;900&display=swap');

.error-page-wrapper {
  font-family: 'Cairo', sans-serif;
  min-height: 100vh;
  /* نفس التدرج اللوني الرسمي للمشروع */
  background: linear-gradient(135deg, #00152e 0%, #002147 100%);
  position: relative;
  overflow: hidden;
  direction: rtl;
}

/* زخرفة الخلفية */
.bg-pattern {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background-image: radial-gradient(circle at 20% 20%, rgba(255, 193, 7, 0.05) 0%, transparent 20%),
                    radial-gradient(circle at 80% 80%, rgba(13, 71, 161, 0.1) 0%, transparent 20%);
  z-index: 1;
}

.content-box {
  position: relative;
  z-index: 2;
  max-width: 600px;
  padding: 20px;
}

/* الألوان */
.text-gold {
  color: #ffc107 !important;
}

.btn-gold {
  background-color: #ffc107;
  color: #002147;
  border: none;
  transition: all 0.3s ease;
}

.btn-gold:hover {
  background-color: #e0a800;
  transform: translateY(-3px);
  box-shadow: 0 10px 20px rgba(255, 193, 7, 0.2);
}

.btn-outline-light:hover {
  background-color: rgba(255, 255, 255, 0.1);
  transform: translateY(-3px);
}

/* تأثير الظل للنص */
.title-shadow {
  text-shadow: 4px 4px 0px rgba(0, 0, 0, 0.3);
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; /* رقم إنجليزي ليكون شكله أفضل */
}

/* حركة بسيطة للأيقونة */
.floating-icon {
  animation: float 3s ease-in-out infinite;
}

@keyframes float {
  0% { transform: translateY(0px); }
  50% { transform: translateY(-15px); }
  100% { transform: translateY(0px); }
}
</style>